import type { FC } from 'react';
import { cx } from '../../cx';
import type { IconProp } from '../../icon-svg/pc-icon';

interface IconLoadingProps extends Omit<IconProp, 'name' | 'size'> {
  size?: 'middle' | 'max' | 'large' | 'small';
}

const sizeStyle: Record<string, string> = {
  middle: '0.5',
  max: '1',
  large: '0.75',
  small: '0.25',
};

export const LoadingIcon = ({ className, size = 'max', style, ...args }: IconLoadingProps) => {
  return (
    <span
      className={cx('loader-icon', className)}
      style={{ ...(style as any), zoom: sizeStyle[size] } as any}
      {...args}
    />
  );
};
